"use client";
import "@repo/edtech-ui-kit/styles";
import "@repo/edtech-player-manager/styles";
import "@repo/edtech-video-player/styles";
import "@repo/edtech-audio-player/styles";
import "@repo/edtech-pdf-player/styles";
import "@repo/edtech-scorm-player/styles";
import { jsx as r, jsxs as O } from "react/jsx-runtime";
import { useState as x, useRef as P, useEffect as B, Fragment as A, memo as M, useMemo as $ } from "react";
import { EdtechPlayerManager as U } from "@repo/edtech-player-manager";
import { BASE_URL as F, useThemeSwitcher as W, Theme as V, EdtechProvider as z } from "@repo/edtech-shared";
import { getUploadUrl as C } from "@repo/edtech-api";
import { EdtechPdfPlayer as Y } from "@repo/edtech-pdf-player";
import { EdtechScormPlayer as j } from "@repo/edtech-scorm-player";
import { SlideCards as K, SlideCardsVariant as X, SlideCardsIndicatorsPosition as q, DownloadFile as J, ImageModalViewer as Q } from "@repo/edtech-ui-kit";
import { EdtechVideoPlayer as Z } from "@repo/edtech-video-player";
import { EdtechAudioPlayer as k } from "@repo/edtech-audio-player";
const e = {
  ROOT: "root",
  TEXT: "text",
  PARAGRAPH: "paragraph",
  HEADING: "heading",
  LINK: "link",
  HR: "horizontalrule",
  VIDEO: "video",
  SCORM: "scorm",
  PDF: "pdf",
  IMAGE: "image",
  TABLE: "table",
  TABLE_ROW: "tablerow",
  TABLE_CELL: "tablecell",
  COLLAPSIBLE_CONTAINER: "collapsible-container",
  COLLAPSIBLE_TITLE: "collapsible-title",
  COLLAPSIBLE_CONTENT: "collapsible-content",
  QUOTE: "quote",
  LINEBREAK: "linebreak",
  CODE: "code",
  CODE_HIGHLIGHT: "code-highlight",
  LAYOUT_CONTAINER: "layout-container",
  LAYOUT_ITEM: "layout-item",
  DOWNLOAD: "download",
  LIST: "list",
  LIST_ITEM: "listitem",
  EDT_SLIDER: "edt-slider",
  EDT_AUDIO: "edt-audio",
  ANCHOR: "anchor",
  HIGHLIGHT_TEXT: "highlight-text"
}, p = {
  HEADING_H1: "heading_h1",
  HEADING_H2: "heading_h2",
  HEADING_H3: "heading_h3",
  HEADING_H4: "heading_h4",
  VIDEO_VERTICAL: "video_vertical",
  IMG_FIGURE: "img_figure",
  IMG_FIGCAPTION: "img_figcaption",
  EDT_SLIDER_INDICATOR: "edt_slider_indicator",
  CODE_STYLE: "code_style"
};
function y(l) {
  var c, h, s = "";
  if (typeof l == "string" || typeof l == "number") s += l;
  else if (typeof l == "object") if (Array.isArray(l)) {
    var t = l.length;
    for (c = 0; c < t; c++) l[c] && (h = y(l[c])) && (s && (s += " "), s += h);
  } else for (h in l) l[h] && (s && (s += " "), s += h);
  return s;
}
function D() {
  for (var l, c, h = 0, s = "", t = arguments.length; h < t; h++) (l = arguments[h]) && (c = y(l)) && (s && (s += " "), s += c);
  return s;
}
const tt = {
  [e.PARAGRAPH]: "edt-longread-theme__text_paragraph",
  [p.HEADING_H1]: "edt-longread-theme__h1",
  [p.HEADING_H2]: "edt-longread-theme__h2",
  [p.HEADING_H3]: "edt-longread-theme__h3",
  [e.TEXT]: "edt-longread-theme__text_span",
  [e.HIGHLIGHT_TEXT]: "edt-longread-theme__text_span",
  [e.LINEBREAK]: "",
  [e.LINK]: "edt-longread-theme__link",
  [e.ANCHOR]: "edt-longread-theme__anchor",
  [e.HR]: "edt-longread-theme__hr",
  [e.SCORM]: "edt-longread-theme__scorm",
  [e.VIDEO]: "edt-longread-theme__video",
  [p.VIDEO_VERTICAL]: "edt-longread-theme__edt-video_vertical",
  [p.IMG_FIGURE]: "edt-longread-theme__figure",
  [p.IMG_FIGCAPTION]: "edt-longread-theme__figcaption",
  [e.PDF]: "edt-longread-theme__pdf",
  [e.TABLE]: "edt-longread-theme__table",
  [e.TABLE_ROW]: "edt-longread-theme__table-row",
  [e.TABLE_CELL]: "edt-longread-theme__table-cell",
  [e.COLLAPSIBLE_CONTAINER]: "edt-longread-theme__collapsible-container",
  [e.COLLAPSIBLE_TITLE]: "edt-longread-theme__collapsible-title",
  [e.COLLAPSIBLE_CONTENT]: "edt-longread-theme__collapsible-content",
  [e.QUOTE]: "edt-longread-theme__quote",
  [e.CODE]: "edt-longread-theme__code",
  [e.CODE_HIGHLIGHT]: "edt-longread-theme__code_highlight",
  [e.LAYOUT_CONTAINER]: "edt-longread-theme__grid-layout",
  [e.LAYOUT_ITEM]: "edt-longread-theme__grid-item",
  [e.LIST]: "edt-longread-theme__list",
  [e.LIST_ITEM]: "edt-longread-theme__list-item",
  [e.EDT_SLIDER]: "edt-longread-theme__edt-slider-wrap",
  [p.EDT_SLIDER_INDICATOR]: "edt-longread-theme__edt-slider-indicator",
  [e.EDT_AUDIO]: "edt-longread-theme__edt-audio-wrap",
  [p.CODE_STYLE]: "edt-longread-theme__text_code"
}, et = () => /* @__PURE__ */ r(
  "svg",
  {
    fill: "none",
    height: "12",
    viewBox: "0 0 12 12",
    width: "12",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M8.98578 7.30842L10.4471 5.84714C11.6075 4.65741 11.5956 2.75578 10.4205 1.58061C9.2453 0.405442 7.34366 0.39359 6.15393 1.55402L4.69266 3.01529M7.77928 4.2218L4.2218 7.77928M3.01529 4.69266L1.55402 6.15393C0.39359 7.34366 0.405442 9.2453 1.58061 10.4205C2.75578 11.5956 4.65741 11.6075 5.84714 10.4471L7.30842 8.98578",
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.2"
      }
    )
  }
), rt = ({
  id: l,
  level: c,
  className: h,
  style: s,
  children: t
}) => {
  const [i, g] = x(!1), [d, n] = x(!1), a = P(0), o = async () => {
    if (!l) return;
    const m = `${window.location.origin}${window.location.pathname}#${l}`;
    await navigator.clipboard.writeText(m), n(!0), window.clearTimeout(a.current), a.current = window.setTimeout(() => {
      n(!1);
    }, 1500);
  };
  return B(() => () => window.clearTimeout(a.current), []), /* @__PURE__ */ O("div", { className: "heading-anchor-wrapper", children: [
    /* @__PURE__ */ r(
      "button",
      {
        "aria-label": "Скопировать ссылку",
        className: D("heading-anchor-btn", { "heading-anchor-btn_visible": i }),
        type: "button",
        onClick: o,
        onMouseEnter: () => g(!0),
        onMouseLeave: () => g(!1),
        children: /* @__PURE__ */ r(et, {})
      }
    ),
    /* @__PURE__ */ r(
      c,
      {
        className: h,
        id: l,
        style: s,
        onMouseEnter: () => g(!0),
        onMouseLeave: () => g(!1),
        children: t
      }
    )
  ] });
};
function N(l) {
  if (typeof l == "number")
    return "left";
  switch ((l || "").toString()) {
    case "center":
      return "center";
    case "right":
      return "right";
    case "justify":
      return "justify";
    case "start":
      return "left";
    case "end":
      return "right";
    default:
      return "left";
  }
}
function G(l, c, h) {
  const s = L(l || "", h), t = L(c || "", h), i = s.fontSize || t.fontSize;
  return {
    ...t,
    ...s,
    ...i ? { fontSize: i } : {}
  };
}
const at = 1, it = 2, lt = 4, st = 8, nt = 16, ot = 32, ct = 64, ht = 128, dt = 256, mt = 512, _t = 1024;
function pt(l) {
  return {
    bold: (l & at) !== 0,
    italic: (l & it) !== 0,
    underline: (l & lt) !== 0,
    strikethrough: (l & st) !== 0,
    code: (l & nt) !== 0,
    subscript: (l & ot) !== 0,
    superscript: (l & ct) !== 0,
    highlight: (l & ht) !== 0,
    lowercase: (l & dt) !== 0,
    uppercase: (l & mt) !== 0,
    capitalize: (l & _t) !== 0
  };
}
function L(l, c) {
  return l ? l.split(";").reduce((h, s) => {
    const [t, i] = s.split(":").map((d) => d?.trim());
    if (!t || !i) return h;
    const g = t.replace(/-([a-z])/g, (d) => d[1].toUpperCase());
    return (!c || !c.includes(g)) && (h[g] = i), h;
  }, {}) : {};
}
const ut = {
  keyword: "#07a",
  string: "#690",
  number: "#905",
  function: "#dd4a68",
  operator: "#9a6e3a",
  punctuation: "#999"
}, gt = `
`, Et = /* @__PURE__ */ new Set([
  "video",
  "scorm",
  "pdf",
  "image",
  "horizontalrule",
  "table",
  "tableRow",
  "tableCell",
  "edt-audio",
  "edt-slider"
]);
function E(l, c) {
  const h = tt[l], s = c?.[l];
  return D(
    "",
    s?.className,
    !s?.replace && h
  );
}
function ft({
  rootNode: l,
  classLib: c,
  isImageWithModal: h = !0
}) {
  if (!l) return null;
  function s(t, i, g = 0) {
    const d = E(t.type, c);
    switch (t.type) {
      case e.PARAGRAPH: {
        const n = t.children || [], a = n.some((_) => Et.has(_.type)), o = G(
          void 0,
          t.textStyle,
          ["color", "backgroundColor"]
        );
        o.textAlign === void 0 && (o.textAlign = N(t.format));
        const f = (typeof t.format == "number" ? t.format : 0) | g;
        let I = `${d} `;
        return t.format === "center" ? I += "edt_text-editor__center-block" : t.format === "right" && (I += "edt_text-editor__right-block"), a ? /* @__PURE__ */ r(
          "div",
          {
            className: I,
            style: o,
            children: n.map((_, T) => /* @__PURE__ */ r(A, { children: s(
              _,
              `${i}-${T}`,
              f
            ) }, `${i}-${T}`))
          },
          i
        ) : /* @__PURE__ */ r(
          "p",
          {
            className: I,
            style: o,
            children: Array.isArray(n) && n.length ? n?.map((_, T) => s(
              _,
              `${i}-${T}`,
              f
            )) : /* @__PURE__ */ r("br", {})
          },
          i
        );
      }
      case e.HEADING: {
        const n = {
          h1: p.HEADING_H1,
          h2: p.HEADING_H2,
          h3: p.HEADING_H3,
          h4: p.HEADING_H4
        }, a = t.tag || "h4", m = (typeof t.format == "number" ? t.format : 0) | g;
        return /* @__PURE__ */ r(
          rt,
          {
            className: E(n[a]),
            id: t?.id,
            level: a,
            style: { textAlign: N(t.format) },
            children: t?.children?.map((f, I) => s(
              f,
              I,
              m
            ))
          },
          i
        );
      }
      case e.HIGHLIGHT_TEXT:
      case e.TEXT: {
        const n = t?.text ?? "", {
          bold: a,
          italic: o,
          underline: m,
          strikethrough: f,
          code: I,
          highlight: _,
          subscript: T,
          superscript: H,
          lowercase: w,
          uppercase: v,
          capitalize: b
        } = pt(t.format);
        let u = n, S = `${d} `;
        I && (u = /* @__PURE__ */ r(
          "code",
          {
            className: E(p.CODE_STYLE, c),
            style: { whiteSpace: "pre-wrap" },
            children: u
          }
        )), a && (u = /* @__PURE__ */ r("strong", { children: u })), o && (u = /* @__PURE__ */ r("em", { className: "edt-longread-theme__textItalic", children: u })), m && (u = /* @__PURE__ */ r("s", { children: u })), f && (u = /* @__PURE__ */ r("u", { children: u })), _ && (u = /* @__PURE__ */ r("mark", { children: u })), T && (S += "edt-longread-theme__text_subscript "), H && (S += "edt-longread-theme__text_superscript "), w && (S += "edt-longread-theme__text_lowercase "), v && (S += "edt-longread-theme__text_uppercase "), b && (S += "edt-longread-theme__text_capitalize ");
        const R = G(t.style);
        return t.type === e.HIGHLIGHT_TEXT && (t?.fontColor && (R.color = t?.fontColor), t?.backgroundColor && (R.backgroundColor = t?.backgroundColor)), /* @__PURE__ */ r(
          "span",
          {
            className: S,
            style: R,
            children: u
          },
          i
        );
      }
      case e.LINEBREAK:
        return /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r("br", {}) }, i);
      case e.LINK:
        return /* @__PURE__ */ r(
          "a",
          {
            className: d,
            href: t.url,
            rel: "noopener noreferrer",
            target: "_blank",
            children: t?.children?.map((n, a) => s(n, a))
          },
          i
        );
      case e.ANCHOR:
        return /* @__PURE__ */ r(
          "a",
          {
            "aria-label": `Якорь ${t.id}`,
            className: d,
            href: t.id,
            id: t.id,
            rel: "noopener noreferrer"
          },
          i
        );
      case e.HR:
        return /* @__PURE__ */ r(
          "hr",
          {
            className: d
          },
          i
        );
      case e.SCORM:
        return /* @__PURE__ */ r(
          j,
          {
            className: D(d, t?.className),
            file: t?.file || "",
            scormid: t?.scormid,
            withScormApi: !1
          },
          i
        );
      case e.VIDEO:
        return /* @__PURE__ */ r(
          Z,
          {
            className: D(d, { [E(p.VIDEO_VERTICAL, c)]: t?.orientation === "vertical" }),
            id: `video-${t?.src}`,
            preview: t?.preview === "default" ? F + "/preview.webp" : t.preview,
            src: t?.src?.startsWith("/") ? C(t?.src) : t.src || "",
            title: `video-${t?.src}`,
            verticalMode: t?.orientation === "vertical"
          },
          i
        );
      case e.IMAGE: {
        const n = t.showCaption && t.caption?.editorState?.root ? s(t.caption.editorState.root, `${i}-caption`) : null, a = {};
        return t?.width && (a.width = `${t.width}px`), t?.height && (a.height = `${t.height}px`), t?.maxWidth && (a.maxWidth = `${t.maxWidth}px`), /* @__PURE__ */ O(
          "figure",
          {
            className: E(p.IMG_FIGURE, c),
            children: [
              /* @__PURE__ */ r(
                Q,
                {
                  alt: t.altText || "",
                  disabledModal: !h,
                  src: t.src.startsWith("/") ? C(t.src) : t.src,
                  style: a
                }
              ),
              n && /* @__PURE__ */ r("figcaption", { className: E(p.IMG_FIGCAPTION, c), children: n })
            ]
          },
          i
        );
      }
      case e.PDF:
        return t.src ? /* @__PURE__ */ r(
          Y,
          {
            className: d,
            filePath: t?.src?.startsWith("/") ? C(t?.src) : t.src || "",
            title: t.title || "Pdf"
          },
          i
        ) : /* @__PURE__ */ r(A, {}, i);
      case e.TABLE: {
        const {
          children: n,
          colWidths: a,
          textStyle: o
        } = t;
        return /* @__PURE__ */ r(
          "div",
          {
            className: "edt-longread-theme__table_wrap",
            "data-align": N(t.format),
            children: /* @__PURE__ */ r(
              "table",
              {
                className: d,
                style: {
                  borderCollapse: "collapse",
                  ...o ? L(o) : {}
                },
                children: /* @__PURE__ */ r("tbody", { children: n?.map((m, f) => {
                  const I = m.height ? `${m.height}px` : void 0;
                  return /* @__PURE__ */ r(
                    "tr",
                    {
                      className: E(e.TABLE_ROW, c),
                      style: {
                        ...L(m.textStyle),
                        height: I
                      },
                      children: m.children?.map((_, T) => {
                        const H = _.headerState === 3 || _.headerState === 1 || _.headerState === 2, w = N(_.format || _.children?.[0]?.format);
                        return /* @__PURE__ */ r(
                          H ? "th" : "td",
                          {
                            className: E(e.TABLE_CELL, c),
                            colSpan: _.colSpan || 1,
                            rowSpan: _.rowSpan || 1,
                            style: {
                              background: _.backgroundColor || "transparent",
                              textAlign: w,
                              ..._.textStyle ? L(_.textStyle) : {},
                              ...a && a[T] ? { width: a[T] } : {}
                            },
                            children: _.children?.map((b, u) => s(b, u))
                          },
                          T
                        );
                      })
                    },
                    f
                  );
                }) })
              },
              i
            )
          }
        );
      }
      case e.COLLAPSIBLE_TITLE: {
        const a = (typeof t.format == "number" ? t.format : 0) | g;
        return /* @__PURE__ */ r(A, { children: t.children?.flatMap((o, m) => s(
          o,
          `${i}-${m}`,
          a
        )) }, i);
      }
      case e.COLLAPSIBLE_CONTENT: {
        const a = (typeof t.format == "number" ? t.format : 0) | g;
        return /* @__PURE__ */ r(A, { children: t?.children?.map((o, m) => s(
          o,
          m,
          a
        )) }, i);
      }
      case e.COLLAPSIBLE_CONTAINER: {
        const n = t.open ?? !1, a = t.children?.find((m) => m.type === "collapsible-title"), o = t.children?.find((m) => m.type === "collapsible-content");
        return /* @__PURE__ */ O(
          "details",
          {
            className: d,
            open: n,
            children: [
              a && /* @__PURE__ */ r(
                "summary",
                {
                  className: E(e.COLLAPSIBLE_TITLE, c),
                  style: {
                    textAlign: N(a.format),
                    cursor: "pointer"
                  },
                  children: s(a, `${i}-title`)
                }
              ),
              o && /* @__PURE__ */ r(
                "div",
                {
                  className: D(E(e.COLLAPSIBLE_CONTENT, c)),
                  style: {
                    textAlign: N(o.format)
                  },
                  children: o?.children?.map((m, f) => s(m, f))
                }
              )
            ]
          },
          i
        );
      }
      case e.QUOTE: {
        const n = {
          ...L(t.textStyle || "", ["color", "backgroundColor"])
        };
        return t.format && (n.textAlign = t.format), /* @__PURE__ */ r(
          "blockquote",
          {
            className: d,
            style: n,
            children: t?.children?.map((a, o) => s(a, o))
          },
          i
        );
      }
      case e.CODE: {
        const n = [1, ...t?.children?.filter(({ type: a }) => a === "linebreak")?.map((a, o) => o + 2)];
        return /* @__PURE__ */ O(
          "code",
          {
            className: d,
            "data-gutter": n?.join(gt),
            "data-lang": t.language || "",
            children: [
              t?.children?.map((a, o) => s(a, o)),
              /* @__PURE__ */ r("br", {})
            ]
          }
        );
      }
      case e.CODE_HIGHLIGHT: {
        const a = {
          color: t.highlightType && ut[t.highlightType] || "inherit",
          ...L(t.style || "")
        };
        return /* @__PURE__ */ r("span", { style: a, children: t.text });
      }
      case e.LAYOUT_CONTAINER: {
        const n = {
          gridTemplateColumns: t.templateColumns || "1fr"
        };
        return /* @__PURE__ */ r(
          "div",
          {
            className: d,
            "data-columns": t.templateColumns || "1fr",
            style: n,
            children: t.children?.map((a, o) => s(a, `${i}-${o}`))
          },
          i
        );
      }
      case e.LAYOUT_ITEM:
        return /* @__PURE__ */ r(
          "div",
          {
            className: d,
            style: { minWidth: 0 },
            children: t?.children?.map((n, a) => s(n, `${i}-${a}`))
          },
          i
        );
      case e.DOWNLOAD:
        return /* @__PURE__ */ r(
          J,
          {
            className: d,
            file: C(t?.file),
            fileName: t?.fileName
          }
        );
      case e.LIST: {
        const n = t.tag === "ol" || t.listType === "number" ? "ol" : "ul", a = {
          textAlign: N(t.format),
          ...t.textStyle ? L(t.textStyle) : {}
        };
        return /* @__PURE__ */ r(
          n,
          {
            className: d,
            start: t.start,
            style: a,
            children: t.children?.map((o, m) => s(o, `${i}-${m}`))
          },
          i
        );
      }
      case e.LIST_ITEM: {
        const n = {
          ...t.textStyle ? L(t.textStyle) : {}
        };
        return /* @__PURE__ */ r(
          "li",
          {
            className: d,
            style: n,
            value: t.value,
            children: t.children?.map((a, o) => s(a, `${i}-${o}`))
          },
          i
        );
      }
      case e.EDT_SLIDER: {
        const n = t.images?.map((a) => a.src.startsWith("/") ? C(a.src) : a.src)?.filter(Boolean) ?? [];
        return n.length ? /* @__PURE__ */ r("div", { className: d, children: /* @__PURE__ */ r(
          K,
          {
            showArrows: !0,
            showIndicators: !0,
            images: n,
            indicatorsClassName: E(p.EDT_SLIDER_INDICATOR, c),
            indicatorsPosition: q.Bottom,
            initialIndex: 0,
            variant: X.Big
          },
          i
        ) }) : null;
      }
      case e.EDT_AUDIO:
        return t.src ? /* @__PURE__ */ r("div", { className: d, children: /* @__PURE__ */ r(
          k,
          {
            id: t.id || crypto?.randomUUID?.() || String(i),
            src: C(t.src),
            title: t.title || "Аудиодорожка"
          },
          i
        ) }) : /* @__PURE__ */ r(A, {}, i);
      default:
        return /* @__PURE__ */ r(A, { children: t?.children?.map((n, a) => s(n, a)) }, i);
    }
  }
  return l?.children?.map((t, i) => s(t, i));
}
const It = "_parsed_17on6_1", Tt = {
  parsed: It
}, Lt = M(({
  content: l,
  isSandbox: c,
  classNameLib: h,
  isImageWithModal: s = !0
}) => {
  W({
    inheritTheme: "app",
    initialTheme: V.Light
  });
  const t = $(() => {
    const i = typeof l == "string" ? JSON.parse(l) : l, g = localStorage.getItem("edt-str") !== null ? JSON.parse(localStorage.getItem("edt-str")) : { json: { root: {} } };
    return ft({
      rootNode: c ? g?.json?.root : i?.root,
      classLib: h,
      isImageWithModal: s
    });
  }, [
    h,
    l,
    s,
    c
  ]);
  return /* @__PURE__ */ O(z, { name: "longread", children: [
    /* @__PURE__ */ r(
      "div",
      {
        className: Tt.parsed,
        id: "edtech-longread",
        children: t
      }
    ),
    /* @__PURE__ */ r(U, {})
  ] });
});
Lt.displayName = "EdtechLongread";
export {
  e as EDT_NODES,
  p as EDT_SUB_NODES,
  Lt as EdtechLongread
};
